import { takeEvery, put } from "redux-saga/effects";
import { request2, request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import history from '../../../router/browserrouter';

export default function* watcherUpdatePickUpStationSaga() {
    yield takeEvery("UPDATE_PICKUPSTATION", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER" });
        let payload = {};
        var url = "api/Admin/update-pickup-station"
        yield request("post", action.payload, url).then(response => {
            payload = response;
        });
        toast.success(payload)
        var formatUrl = "api/Admin/get-pickup-stations"
        yield request("get", action.payload, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "PICKUPSTATION_LIST", payload: payload })
        yield request("get", payload, "api/Admin/get-countries-dropdown").then(response => {
            payload = response;
        });
        yield put({ type: "COUNTRIES_DROPDOWN", payload: payload })


        yield put({ type: "DISPLAY_LOADER" });
    } catch (e) {
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        console.log("update-pick-up-station-saga", e)
        yield put({ type: "DISPLAY_LOADER" });
        console.log("update-pick-up-station-saga", e.response)
        console.log(e.response)
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
